import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e80badb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "patientNoticeBoard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "환자 공지사항", -1))
const _hoisted_3 = { class: "board-top mb20" }
const _hoisted_4 = { class: "lang-tabs" }
const _hoisted_5 = { class: "board-btn-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "hidden" }, "글 목록", -1))
const _hoisted_7 = { class: "table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "hidden" }, "분류", -1))
const _hoisted_9 = { class: "tr th" }
const _hoisted_10 = { class: "col1" }
const _hoisted_11 = { class: "checkbox-wrap" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col2 col-number" }, "No.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col3" }, "등록일", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col4" }, "제목", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col5" }, "작성자", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "hidden" }, "내용", -1))
const _hoisted_17 = { class: "list-loading" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "err-server"
}
const _hoisted_22 = { class: "err-server-msg" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "checkbox-wrap" }
const _hoisted_26 = { class: "col2 col-number" }
const _hoisted_27 = { class: "col3" }
const _hoisted_28 = { class: "col4 col-detail txt-wrap" }
const _hoisted_29 = { class: "col5" }
const _hoisted_30 = { class: "page-nation-vue" }
const _hoisted_31 = {
  key: 0,
  class: "currentPopup"
}
const _hoisted_32 = {
  key: 0,
  class: "resultPopup"
}

import { onBeforeMount, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { computed, ref } from '@vue/reactivity';
import LangTabs from '@/components/button/LangTabs.vue';
import BoardPostPopup from './popup/BoardPostPopup.vue';
import BoardViewPopup from './popup/BoardViewPopup.vue';
import PageNation from '@/components/item/PageNation.vue';
import ConfirmPopup from '@/components/popup/ConfirmPopup.vue';
import ExceptionPopup from '@/components/popup/ExceptionPopup.vue';
import ResultPopup from '@/components/popup/ResultPopup.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PatientNoticeBoard',
  setup(__props) {

const store = useStore();
const Cs = store.state.moduleCs;
/**** popup ------------------- */
var currentPopup = ref(null);
var popupTitle = ref('');
var popupDesc = ref('');
var exception = computed(() => Cs.exception);
var result = computed(() => Cs.result);
let onCallMethod = () => {
  return console.log('on call');
};
const close_currentPopup = () => {
  currentPopup.value = null;
};
const close_resultPopup = () => {
  store.commit('moduleCs/reset_result', { root: true });
  setNoticeList(pageNumber.value);
};
const onClick_cancel = () => {
  close_currentPopup();
};
const onClick_close = () => {
  close_currentPopup();
};
const onClick_confirm = async () => {
  close_currentPopup();
  onCallMethod();
};
/**** data -------------------- */
var faqList = computed(() => Cs.boardList);
var totalCount = computed(() => Cs.totalCount);
var checkedItems = computed(() => store.getters['moduleCs/getCheckedItems']);
var propsPageNumber = ref(1);
var pageNumber = ref(1);
var lastPageNumber = computed(() => store.getters['moduleCs/getLastPageNumber']);
var rowNumber = ref(8);
var searchWord = ref('');
var isOnListLoading = ref(true);
var searchTypes = ref(['']);
var isChecked_faq_all = ref(false);
var currentItemSid = ref(0);
var langOption = ref(''); // 영어: en, 한국어: kr, 러시아어: ru
var boardCode = ref({
  boardCategory: '103',
  boardType: '000',
});
/**** methods ----------------- */
const onClick_langOption = (option: string) => {
  langOption.value = option;
};
const onClick_pageNumber = (num: number) => {
  pageNumber.value = num;
};
const onClick_item = async (itemSid: number) => {
  popupTitle.value = '공지사항 보기';
  currentItemSid.value = itemSid;
  currentPopup.value = BoardViewPopup;
};
const closeCurrentPopup = () => {
  currentPopup.value = null;
};
const delete_notice = async () => {
  store.dispatch('moduleCs/deleteBoardItem', checkedItems.value, { root: true });
};
const onClick_delete = async () => {
  popupTitle.value = '공지사항 삭제';
  if (checkedItems.value.length === 0) {
    popupDesc.value = '삭제할 게시글을 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    onCallMethod = delete_notice;
    if (checkedItems.value.length === 1) {
      popupDesc.value = `'${checkedItems.value[0].title}' 게시글을 삭제할까요?`;
      currentPopup.value = ConfirmPopup;
    } else {
      popupDesc.value = `'${checkedItems.value[0].title}' 외 ${checkedItems.value.length - 1}개 게시글을 삭제할까요?`;
      currentPopup.value = ConfirmPopup;
    }
  }
};
const onClick_post = () => {
  // console.log('onClick_post');
  popupTitle.value = '환자 공지사항 글쓰기';
  currentPopup.value = BoardPostPopup;
};
const onCheck_faq_item = (index) => {
  // console.log('onCheck_faq_item');
  if (Cs.boardList[index].isChecked) {
    store.commit('moduleCs/uncheck_item', index, { root: true });
  } else {
    store.commit('moduleCs/check_item', index, { root: true });
  }
};
const onCheck_faq_all = () => {
  // console.log('onCheck_faq_all');
  if (isChecked_faq_all.value) {
    isChecked_faq_all.value = false;
    uncheckNoticeList();
  } else {
    isChecked_faq_all.value = true;
    checkNoticeList();
  }
};
const uncheckNoticeList = async () => {
  store.commit('moduleCs/uncheck_all', { root: true });
};
const checkNoticeList = async () => {
  store.commit('moduleCs/check_all', { root: true });
};
const setCategorySelects = async () => {
  searchTypes.value = ['제목', '내용'];
};
const setPageNation = async () => {
  if (totalCount.value % rowNumber.value === 0) {
    lastPageNumber.value = Math.floor(totalCount.value / rowNumber.value);
  } else {
    lastPageNumber.value = Math.floor(totalCount.value / rowNumber.value) + 1;
  }
};
const setNoticeList = async (pNum: number) => {
  pageNumber.value = pNum;
  isOnListLoading.value = true;
  var board = await {
    board_category_code: boardCode.value.boardCategory,
    board_type_code: boardCode.value.boardType,
    page: pageNumber.value,
    rows: rowNumber.value,
    search_text: searchWord.value,
  };
  await (() => {
    // 1. 게시판 목록 조회
    store.dispatch('moduleCs/getBoardList', board, { root: true });
  })();
  await uncheckNoticeList();
  setTimeout(() => {
    isOnListLoading.value = false;
  }, 800);
};
/**** content -----------------
 *
 * 환자 공지사항
 * /
 * /
/**** hook -------------------- */
onBeforeMount(() => {
  store.state.moduleCs.boardList = [];
  langOption.value = 'en';
});
onMounted(() => {
  (async () => {
    await (() => {
      setNoticeList(1);
      setCategorySelects();
    })();
  })();
});
watch(
  () => pageNumber.value,
  (newValue, oldValue) => {
    setNoticeList(pageNumber.value);
  },
  { deep: true }
);
watch(
  () => langOption.value,
  (newValue, oldValue) => {
    if (newValue === `en`) {
      boardCode.value.boardCategory = `103`;
      return;
    } else if (newValue === `kr`) {
      boardCode.value.boardCategory = `003`;
      return;
    } else if (newValue === `ru`) {
      boardCode.value.boardCategory = `203`;
      return;
    }
  },
  { deep: true }
);
watch(
  () => boardCode.value,
  (newValue, oldValue) => {
    setNoticeList(1);
  },
  { deep: true }
);
watch(
  () => currentPopup.value,
  (newValue, oldValue) => {
    if (oldValue !== ConfirmPopup && newValue === null) {
      setNoticeList(pageNumber.value);
    }
  },
  { deep: true }
);
watch(
  () => pageNumber.value,
  () => {
    propsPageNumber.value = pageNumber.value;
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LangTabs, { onOnClick_langOption: onClick_langOption })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn-negative",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_delete()))
          }, "삭제"),
          _createElementVNode("button", {
            class: "btn-positive",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_post()))
          }, "글쓰기")
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["checkbox checkbox-all", [{ 'checked-sub1': _unref(isChecked_faq_all) === true }, { unchecked: _unref(isChecked_faq_all) === false }]]),
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onCheck_faq_all()), ["stop"]))
              }, null, 2)
            ])
          ]),
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ]),
        _hoisted_16,
        _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_20, 512), [
          [_vShow, _unref(isOnListLoading)]
        ]),
        (!_unref(isOnListLoading) && _unref(exception).boardList.bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("p", {
                class: _normalizeClass([{ 'err-server-bang': _unref(exception).boardList.type === 'bang' }, { 'err-server-empty': _unref(exception).boardList.type === 'empty' }])
              }, null, 2),
              _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(exception).boardList.desc), 1)
            ]))
          : (!_unref(isOnListLoading) && !_unref(exception).boardList.bool)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(faqList), (item, index) => {
                return (_openBlock(), _createElementBlock("ul", {
                  class: "td",
                  key: item
                }, [
                  _createElementVNode("li", {
                    class: "tr",
                    onClick: ($event: any) => (onClick_item(item.itemSid))
                  }, [
                    _createElementVNode("span", {
                      class: "col1",
                      onClick: _withModifiers(($event: any) => (onCheck_faq_item(index)), ["stop"])
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["checkbox", [{ 'checked-main': item.isChecked === true }, { unchecked: item.isChecked === false }]])
                        }, null, 2)
                      ])
                    ], 8, _hoisted_24),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(totalCount) - _unref(rowNumber) * (_unref(pageNumber) - 1) - index), 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(item.createdDate), 1),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(item.title), 1),
                    _createElementVNode("span", _hoisted_29, _toDisplayString(item.writer), 1)
                  ], 8, _hoisted_23)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_30, [
        _createVNode(PageNation, {
          "props-page-number": _unref(propsPageNumber),
          "total-count": _unref(totalCount),
          "row-number": _unref(rowNumber),
          "last-page-number": _unref(lastPageNumber),
          onOnClick_pageNumber: onClick_pageNumber
        }, null, 8, ["props-page-number", "total-count", "row-number", "last-page-number"])
      ], 512), [
        [_vShow, !_unref(isOnListLoading) && !_unref(exception).boardList.bool]
      ])
    ]),
    _createVNode(_Transition, { name: "currentPopup" }, {
      default: _withCtx(() => [
        (_unref(currentPopup) !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                "popup-title": _unref(popupTitle),
                "popup-desc": _unref(popupDesc),
                "board-code": _unref(boardCode),
                "item-sid": _unref(currentItemSid),
                onOnClick_close: _cache[3] || (_cache[3] = ($event: any) => (onClick_close())),
                onOnClick_cancel: _cache[4] || (_cache[4] = ($event: any) => (onClick_cancel())),
                onOnClick_confirm: _cache[5] || (_cache[5] = ($event: any) => (onClick_confirm())),
                onCloseCurrentPopup: _cache[6] || (_cache[6] = ($event: any) => (closeCurrentPopup()))
              }, null, 40, ["popup-title", "popup-desc", "board-code", "item-sid"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "resultPopup" }, {
      default: _withCtx(() => [
        (_unref(result).bool)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(ResultPopup, {
                "result-title": _unref(result).title,
                "result-desc": _unref(result).desc,
                onOnClick_close: _cache[7] || (_cache[7] = ($event: any) => (close_resultPopup()))
              }, null, 8, ["result-title", "result-desc"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})